import { supabase } from './supabase';

export interface ReferralSignupOffer {
  ok: boolean;
  partner_name?: string;
  code?: string;
  signup_discount_enabled?: boolean;
  signup_discount_percent?: number | null;
  commission_percent?: number;
  commission_type?: 'one_time' | 'recurring';
}

export async function fetchReferralSignupOffer(code: string): Promise<ReferralSignupOffer> {
  if (!supabase) throw new Error('Supabase client not initialized');

  const { data, error } = await supabase.rpc('get_referral_signup_offer', {
    p_code: code,
  });

  if (error) throw error;
  return (data ?? { ok: false }) as ReferralSignupOffer;
}

export function formatReferralDiscountLabel(percent: number): string {
  return `${percent}% off your first month on the base platform plan`;
}

/**
 * Records a visit to a referral partner's link (top of the conversion funnel).
 * De-duped once per browser session per code so refreshes don't inflate counts.
 * Best-effort — never throws.
 */
export async function recordReferralVisit(code: string): Promise<void> {
  try {
    if (!supabase || !code) return;
    const key = `nexus_referral_visit_logged:${code.toLowerCase()}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    await supabase.rpc('record_referral_visit', {
      p_code: code,
      p_user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      p_referrer: typeof document !== 'undefined' ? document.referrer || null : null,
    });
  } catch {
    /* best-effort analytics; ignore */
  }
}
